import React, { useState } from "react";
import { Link, NavLink  } from "react-router-dom";
import {
  Button,
} from "react-bootstrap";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const services = [
  {
    category: "Marketing",
    subModules: [
      "Advertising",
      "Branding",
      "Direct Marketing",
      "Public Relations",
      "Market Research",
      "Marketing Strategy",
      "Media Planning & Buying",
      "Event Marketing",
      "Other Marketing",
      "Product Marketing",
      "Sports Marketing",
      "Event Management",
      "Fractional CMO Services",
    ],
  },
  {
    category: "Digital Marketing",
    subModules: [
      "SEO",
      "Content Marketing",
      "Social Media Marketing",
      "Email Marketing",
      "Affiliate Marketing",
      "Online Advertising",
      "Mobile Marketing",
      "Conversion Rate Optimization",
      "Influencer Marketing",
      "Other Digital Marketing",
    ],
  },
  // Add more categories as needed
];

const CreateCompanyProfileSearch = () => {
  const [step, setStep] = useState(1);
  const [companyName, setCompanyName] = useState("");
  const [companyInfo, setCompanyInfo] = useState({ industry: "", size: "" });
  const [manager, setManager] = useState({ name: "", email: "" });

  const [businessEmail, setBusinessEmail] = useState("");
  const [identityName, setIdentityName] = useState("");
  const [designation, setDesignation] = useState("");

  const [description, setDescription] = useState("");

  const handleNext = () => setStep((prev) => prev + 1);
  const handlePrev = () => setStep((prev) => prev - 1);
  const handleFinish = () => {
    console.log("Form Submitted:", { companyName, companyInfo, manager });
  };

  const steps = [
    "Create Your Company",
    "Validate",
    "Company Information",
  ];

  const [selectedSubModules, setSelectedSubModules] = useState([]);

  const handleSelect = (category, subModule) => {
    setSelectedSubModules(prev => {
      if (prev.some(item => item.subModule === subModule)) return prev;
      return [...prev, { category, subModule }];
    });
  };

  const handleRemove = (subModule) => {
    setSelectedSubModules(prev => prev.filter(item => item.subModule !== subModule));
  };



  const [logo, setLogo] = useState(null);
  const [banner, setBanner] = useState(null);


  const handleImageUpload = (event, type) => {
    if (event.target.files && event.target.files[0]) {
      const imageURL = URL.createObjectURL(event.target.files[0]);
      if (type === "logo") {
        setLogo(imageURL);
      } else {
        setBanner(imageURL);
      }
    }
  };

  const handleRemoveImage = (type) => {
    if (type === "logo") {
      setLogo(null);
    } else {
      setBanner(null);
    }
  };




  const handleVerifyEmail = () => {
    // Add email verification logic here
    console.log("Verifying email:", businessEmail);
  };



  return (
    <div className="d-flex flex-column">
      {/* Progress Header */}
      <div className="container">
        <div className="d-flex justify-content-center flex-wrap gap-4 stepsmargin ">
          {steps.map((label, index) => (
            <div
              key={index}
              className={`d-flex align-items-center px-4 py-3 rounded-pill fw-semibold shadow-sm ${
                step === index + 1
                  ? "bg-primary text-white"
                  : "bg-white text-muted border"
              }`}
              style={{ cursor: "default" }}
            >
              <span
                className={`me-2 rounded-circle d-flex align-items-center justify-content-center ${
                  step === index + 1 ? "bg-white text-primary" : "bg-light"
                }`}
                style={{ width: "24px", height: "24px" }}
              >
                {index + 1}
              </span>
              {label}
            </div>
          ))}
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-grow-1 d-flex align-items-center pt-0 mt-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-md-12 col-lg-12">
              <div className="">
                <div className="p-3 d-flex justify-content-center">
                  {step === 1 && (
                    <>
                      <div className="col-12 col-md-8 col-lg-7 ">
                        <div className="card p-5 shadow-sm border-0 rounded-4">
                          <div className="p-4">
                          <h3 className="form-header text-center mb-2">
                            What is your Company name?
                          </h3>
                          <p className="text-muted text-center mb-4">
                          A simple way to hyper-grow your business is to get your company listed at LeadStream
                          </p>
                          <input
                            type="text"
                            className="form-control form-control-lg p-3 rounded-3 border-1 mb-4"
                            placeholder="Enter your company name..."
                            value={companyName}
                            onChange={(e) => setCompanyName(e.target.value)}
                          />
                          <div className="d-flex justify-content-end">
                            <Link
                              to="/MyProfile"
                              className="btn btn-outline-primary text-primary me-3 py-2 px-4 rounded-3 me-2"
                            >
                              Skip
                            </Link>

                            <button
                              className="btn btn-primary rounded-3 fw-regular py-2 px-4"
                              onClick={handleNext}
                            >
                              Continue
                            </button>
                          </div>
                        </div>
                        </div>
                      </div>
                    </>
                  )}





{step === 2 && (
                    <div className="col-12 col-md-8 col-lg-7">
                      <div className="card p-5 shadow-sm border-0 rounded-4">
                        <div className="p-4">
                          <h3 className="form-header text-center mb-2">
                            Validate your Profile
                          </h3>
                          <p className="text-muted text-center mb-4">
                            Verify your company identity
                          </p>

                          <div className="mb-4">
                            <label className="form-label">Company Email Id</label>
                            <div className="input-group">
                              <input
                                type="email"
                                className="form-control p-3 rounded-3 me-3"
                                placeholder="Enter your company email..."
                                value={businessEmail}
                                onChange={(e) => setBusinessEmail(e.target.value)}
                              />
                              <button
                                className="btn btn-outline-primary rounded-3 text-primary"
                                onClick={handleVerifyEmail}
                              >
                                Verify
                              </button>
                            </div>
                          </div>

                          <div className="mb-4">
                            <label className="form-label">Your Name</label>
                            <input
                              type="text"
                              className="form-control p-3 rounded-3 mb-3"
                              placeholder="Enter your name..."
                              value={identityName}
                              onChange={(e) => setIdentityName(e.target.value)}
                            />
                            </div>


                            <div className="mb-4">
                            <label className="form-label">Which role belogs to you?</label>
                            <select
                              className="form-select p-3 rounded-3"
                              value={designation}
                              onChange={(e) => setDesignation(e.target.value)}
                            >
                              <option value="">Select Designation</option>
                              <option value="Founder">Founder</option>
                              <option value="Cofounder">Co Founder</option>
                              <option value="CEO">CEO</option>
                              <option value="Chairman">Chairman</option>
                              <option value="Vicpresident">Vic President</option>
                            </select>
                          </div>

                          <div className="d-flex justify-content-end">
                            <button
                              className="btn btn-outline-primary text-primary py-2 px-4 rounded-3 me-3"
                              onClick={handlePrev}
                            >
                              Back
                            </button>
                            <button
                              className="btn btn-primary rounded-3 fw-regular py-2 px-4"
                              onClick={handleNext}
                            >
                              Continue
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}




                  {step === 3 && (
                    <>
                      <div className="">
                        <div className="">
                          <div className="row justify-content-center">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                              <form className="">
                                <div class="card rounded-4 shadow-sm border-0 p-4 mb-5">
                                  <div class="card-header border-bottom">
                                    <h5>Company Information</h5>
                                    <p className="pt-0 text-secondary">
                                      Fill in some generic information about
                                      your company.
                                    </p>
                                  </div>

                                  <div class="card-body pt-4">
                                    <div class="row g-8">
                                      <div class="col-md-12 mb-4 ">
                                        <label
                                          for="firstName"
                                          class="form-label"
                                        >
                                          Company Name
                                        </label>
                                        <input
                                          class="form-control"
                                          type="text"
                                          id="companyname"
                                          name="companyname"
                                          value="Veritis Group Inc"
                                        />
                                      </div>

                                      <div class="col-md-12 mb-4 ">
                                        <label
                                          for="firstName"
                                          class="form-label"
                                        >
                                          Company Tagline (Optional)
                                        </label>
                                        <input
                                          class="form-control"
                                          type="text"
                                          id="companyname"
                                          name="companyname"
                                          value="US-based IT Services Provider: Cloud, DevOps, Digital Transformation, Identity Management, and Artificial Intelligence!"
                                          autofocus=""
                                        />
                                      </div>
                                      <div class="col-md-6 ">
                                        <label
                                          for="lastName"
                                          class="form-label"
                                        >
                                          Your Team
                                        </label>
                                        <input
                                          class="form-control"
                                          type="number"
                                          name="number"
                                          id="number"
                                          value="50"
                                        />
                                      </div>
                                      <div class="col-md-6 mb-4">
                                        <label
                                          for="currency"
                                          class="form-label"
                                        >
                                          Founded in (Optional)
                                        </label>
                                        <div class="position-relative">
                                          <select
                                            id="founded"
                                            class="select2 form-select select2-hidden-accessible"
                                            data-select2-id="founded"
                                            tabindex="-1"
                                            aria-hidden="true"
                                          >
                                            <option
                                              value=""
                                              data-select2-id="8"
                                            >
                                              2024
                                            </option>
                                            <option value="usd">2023</option>
                                            <option value="euro">2022</option>
                                            <option value="pound">2021</option>
                                            <option value="bitcoin">
                                              2021
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                      <div class="col-md-6 mb-4">
                                        <label
                                          for="language"
                                          class="form-label"
                                        >
                                          Language Spoken
                                        </label>
                                        <div class="position-relative">
                                          <select
                                            id="language"
                                            class="select2 form-select select2-hidden-accessible"
                                            data-select2-id="language"
                                            tabindex="-1"
                                            aria-hidden="true"
                                          >
                                            <option value="en">English</option>
                                            <option value="fr">French</option>
                                            <option value="de">German</option>
                                            <option value="pt">
                                              Portuguese
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                      <div class="col-md-6 ">
                                        <label
                                          for="lastName"
                                          class="form-label"
                                        >
                                          Annual turnover (optional)
                                        </label>
                                        <input
                                          class="form-control"
                                          type="number"
                                          name="number"
                                          id="number"
                                          value="250"
                                        />
                                      </div>

                                      <div class="col-md-12 mb-4 ">
                                        <label
                                          for="firstName"
                                          class="form-label"
                                        >
                                          Company Description (Optional)
                                        </label>
                                        <ReactQuill
                                          theme="snow"
                                          style={{ height: "200px" }}
                                          value={description}
                                          onChange={setDescription}
                                        />
                                      </div>




                                      <div class="card-header mt-4 pt-5 border-bottom">
                                        <h5>Upload</h5>
                                        <p className="pt-0 text-secondary">
                                          Upload your company logo and banner.
                                        </p>
                                      </div>




    <div className="row pt-4">
      {/* Logo Upload Section */}
      <div className="col-md-5">
        <div className="bg-skyblue mb-5 p-5 border rounded text-start">
          <label className="form-label">Logo (optional)</label>
          {logo ? (
            <div className="text-center">
              <img src={logo} className="img-fluid img-thumbnail mb-3" alt="Logo Preview" />
              <button className="btn btn-danger btn-sm" onClick={() => handleRemoveImage("logo")}>
                Remove
              </button>
            </div>
          ) : (
            <input type="file" className="form-control" accept="image/*" onChange={(e) => handleImageUpload(e, "logo")} />
          )}
        </div>
      </div>

      {/* Banner Upload Section */}
      <div className="col-md-7">
        <div className="bg-skyblue mb-5 p-5 border rounded text-start">
          <label className="form-label">Banner (optional)</label>
          {banner ? (
            <div>
              <img src={banner} className="img-fluid img-thumbnail mb-3" alt="Banner Preview" />
              <button className="btn btn-danger btn-sm" onClick={() => handleRemoveImage("banner")}>
                Remove
              </button>
            </div>
          ) : (
            <input type="file" className="form-control" accept="image/*" onChange={(e) => handleImageUpload(e, "banner")} />
          )}
        </div>
      </div>
    </div>



                                    </div>

                                    <div className="d-flex justify-content-end">
                                      <button
                                        className="btn btn-outline-primary text-primary me-3 py-2 px-4 rounded-3 me-2"
                                        onClick={handlePrev}
                                      >
                                        Back
                                      </button>
                                      <Button
  as={NavLink}
  to="/CompanyProfile"
  className="btn btn-primary rounded-3 fw-regular py-2 px-4"
>
  Create Profile
</Button>
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>

                        <div></div>
                      </div>
                    </>
                  )}









                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateCompanyProfileSearch;
